import { SEARCH_GRANTS_QUERYING_STATUS_KEY } from '../../tool-card-config';
export const getFundingExplorerUrl = (tool) => {
    var _a;
    if (!tool.progress || tool.progress.length === 0) {
        return null;
    }
    return (((_a = tool.progress.find((progress) => progress.status_key === SEARCH_GRANTS_QUERYING_STATUS_KEY)) === null || _a === void 0 ? void 0 : _a.content) || null);
};
